import { Day, UsersPermissionsUser } from "../gql/generated-types";
import { UserForCalendar } from "./../types/index";

export * from "./dates";
export * from "./days";
export * from "./users";

export const getFirstItem = <T>(stringArray?: T[] | null) => {
  if (!stringArray?.length) return undefined;
  const first = stringArray?.find((element) => element !== undefined);
  return first;
};

export const groupUsersByDay = (list: Day[], returnUsersProp = true) => {
  const temp: {
    [name: string]: { label: string; value: string };
  } = {};

  const grouped = list.reduce((previous, currentItem) => {
    const date = currentItem?.date;
    if (!previous[date]) {
      previous[date] = [];
    }
    const user = currentItem?.user as UsersPermissionsUser;
    const hoursOff = currentItem?.hoursOff as UserForCalendar["hoursOff"];

    const item: UserForCalendar = {
      hoursOff,
      user
    };
    previous[date].push(item);

    if (returnUsersProp && !temp[user?.lastName ?? ""]) {
      temp[user?.lastName ?? ""] = {
        label: `${user?.firstName ?? ""} ${user?.lastName ?? ""}`,
        value: user?.color ?? "#red"
      };
    }
    return previous;
  }, {} as Record<string, UserForCalendar[]>);

  return {
    grouped,
    users: Object.values(temp).sort((a, b) =>
      a.label > b.label ? 1 : b.label > a.label ? -1 : 0
    )
  };
};

export const groupBy = <T, K extends keyof T>(list: T[], criteria: K) =>
  list.reduce((previous, currentItem) => {
    if (!previous[criteria]) {
      previous[criteria] = [];
    }
    previous[criteria].push(currentItem);
    return previous;
  }, {} as Record<K, T[]>);
